if (!customElements.get('lookbook-icon')) {
  customElements.define('lookbook-icon', class LookbookIcon extends HTMLElement {
    connectedCallback() {
      this.pin = this.querySelector('.lookbook-icon__pin');
      this.card = this.querySelector('.lookbook-icon__card');
      this.container = this.closest('.lookbook-card');
      if (!this.pin || !this.card || !this.container) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.pinned = false;
      this.setOpen(false);
      this.pin.addEventListener('click', () => {
        this.pinned = !this.pinned;
        this.setOpen(this.pinned);
      }, { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.setOpen(true);
      }, { signal });
      this.addEventListener('pointerleave', () => {
        if (!this.pinned && !this.contains(document.activeElement)) this.setOpen(false);
      }, { signal });
      this.addEventListener('focusin', () => this.setOpen(true), { signal });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {
          this.pinned = false;
          this.setOpen(false);
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.pinned = false;
          this.pin.focus();
          this.setOpen(false);
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) {
          this.pinned = false;
          this.setOpen(false);
        }
      }, { signal });
      this.addEventListener('shopify:block:select', () => this.setOpen(true), { signal });
      this.addEventListener('shopify:block:deselect', () => this.setOpen(false), { signal });
      document.addEventListener('matchMobile', () => this.positionCard(), { signal });
      document.addEventListener('unmatchMobile', () => this.positionCard(), { signal });
      this.resizeObserver = new ResizeObserver(() => this.positionCard());
      this.resizeObserver.observe(this.container);
      this.positionCard();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }

    setOpen(open) {
      this.classList.toggle('is-active', open);
      this.pin.setAttribute('aria-expanded', String(open));
      this.card.inert = !open;
      if (open) this.positionCard();
    }

    positionCard() {
      if (!this.container || !this.card) return;
      const pin = this.getBoundingClientRect();
      const container = this.container.getBoundingClientRect();
      const x = pin.left - container.left;
      const y = pin.top - container.top;
      const width = this.card.offsetWidth;
      let position = y > this.card.offsetHeight ? 'top' : 'bottom';
      if (x + pin.width > width) position += '-left';
      else if (container.width - x > width) position += '-right';
      this.dataset.position = position;
    }
  });
}
